import { Button } from "@mantine/core";
import React from "react";
import { HSpace } from ".";

const EditSaveAbort: React.FC<{
  saveCb: () => void;
  editable?: boolean;
  editMode: boolean;
  editModeCb: (enabled: boolean) => void;
  disabled?: boolean;
  hidden?: boolean;
  big?: boolean;
}> = ({ saveCb, editMode, editModeCb, disabled = false, editable = true, hidden = false, big = false }) => {
  return (
    <div>
      {editMode === false && editable === true && hidden === false && (
        <>
          {big === true ? (
            <Button
              px="sm"
              variant="outline"
              onClick={() => editModeCb(true)}
              leftSection={<i className="fa fa-pencil" />}
            >
              Rediger
            </Button>
          ) : (
            <i className="fa fa-pencil fa-fw editIcon" onClick={() => editModeCb(true)} />
          )}
        </>
      )}
      {editMode === true && (
        <div>
          <div className="d-flex">
            <Button
              px="sm"
              color="green"
              onClick={() => saveCb()}
              disabled={disabled}
              leftSection={<i className="fa fa-floppy-o" />}
            >
              Lagre
            </Button>
            <HSpace />
            <Button
              px="sm"
              variant="outline"
              onClick={() => editModeCb(false)}
              color="warmgray.7"
              leftSection={<i className="fa fa-times" />}
            >
              Avbryt
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditSaveAbort;
